<template lang="pug">
    div
        Poptip(width="750" transfer v-model="visible")
            Button(shape="circle" icon="md-help" size="small")
            template(slot="title")
                p {{ this.$i18n.t("wafrules.wafHeadersType") }}
            template(slot="content")
                p {{ `${this.$i18n.t("wafrules.wafHeaders")} : ${this.$i18n.t("wafrules.wafHeaderDescription")}` }}
                p {{ `${this.$i18n.t("wafrules.wafHeadersSet")} : ${this.$i18n.t("wafrules.wafHeaderListDescription")}`}}
</template>
<script>
export default {
    name: "ExplainWafHeaderType",
    data() {
        return {
            visible: false,
        };
    },
};
</script>



// WEBPACK FOOTER //
// src/components/PoptipInfos/ExplainWafHeaderType.vue